// extracted by mini-css-extract-plugin
export default {"isProgress":"AppointmentCard_isProgress__Sa31O"};